import { render } from "./TemplateMenu.vue?vue&type=template&id=c2d6b41a"
import script from "./TemplateMenu.vue?vue&type=script&lang=js"
export * from "./TemplateMenu.vue?vue&type=script&lang=js"

import "./TemplateMenu.vue?vue&type=style&index=0&id=c2d6b41a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__